import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
import PropTypes from "prop-types";
import { calculateRem } from "@uie/javascript-style-helpers";
import { AccordionHeader as CoreAccordionHeader } from "@vds-core/accordions";
import { TextLink } from "@vds/buttons";
import { colors, calculateSpacing } from "@vds/theme";
var propTypes = {
  /**
   * @deprecated
   * If provided, this function will be called if AccordionHeader is clicked. This will return (event, active state of the accordion item)
   */
  clickHandler: PropTypes.func
};

var AccordionHeader = /*#__PURE__*/function (_React$Component) {
  _inherits(AccordionHeader, _React$Component);

  var _super = _createSuper(AccordionHeader);

  function AccordionHeader(props) {
    var _this;

    _classCallCheck(this, AccordionHeader);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_calcPaddingTop", function (viewport) {
      return calculateSpacing("2X"); //8px
    });

    _defineProperty(_assertThisInitialized(_this), "_calcPaddingBottom", function (viewport, opened) {
      return opened ? calculateSpacing("3X") //12px
      : "23px"; // 23px to avoid flicker for 1.0
    });

    _defineProperty(_assertThisInitialized(_this), "_calcTextLinkSize", function (viewport) {
      return "small";
    });

    _defineProperty(_assertThisInitialized(_this), "_calcTextPaddingRight", function (viewport) {
      return "60px"; //48px for icon width and 12px padding
    });

    _defineProperty(_assertThisInitialized(_this), "_calcToggleIconPositionHover", function (viewport, opened) {
      return opened ? "6px" : "10px";
    });

    _defineProperty(_assertThisInitialized(_this), "_calcIconColor", function (surface, clicked) {
      if (surface === "dark") {
        return clicked ? colors.coolGray6 : colors.white;
      } else {
        return clicked ? colors.coolGray6 : colors.black;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_calcTextLinkColor", function (surface, hovered, clicked) {
      return clicked ? colors.coolGray6 : hovered ? surface === "dark" ? colors.blueInverted : colors.blue : surface === "dark" ? colors.white : colors.black;
    });

    _defineProperty(_assertThisInitialized(_this), "_calcTextLinkBorder", function (surface, hovered, clicked) {
      return clicked ? "".concat(calculateRem(1), " solid ").concat(colors.coolGray6) : hovered ? "".concat(calculateRem(1), " solid ").concat(surface === "dark" ? colors.blueInverted : colors.blue) : "".concat(calculateRem(1), " solid ").concat(surface === "dark" ? colors.white : colors.black);
    });

    return _this;
  }

  _createClass(AccordionHeader, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(CoreAccordionHeader, _extends({}, this.props, {
        onClick: this.props.onClick || this.props.clickHandler,
        focusRingBorderRadius: false,
        customChildrenTypography: true // apply Body config for custom child passed in
        ,
        TextLinkComponent: TextLink,
        bold: true,
        toggleIconPositionSmall: true,
        fixedTextLinkLabel: true,
        toggleIconTransitionTime: "350ms",
        openAccordionTriggerLabel: "Change",
        closeAccordionTriggerLabel: "Cancel",
        iconSize: "medium",
        iconBold: true,
        calcPaddingTop: this._calcPaddingTop,
        calcPaddingBottom: this._calcPaddingBottom,
        calcTextLinkSize: this._calcTextLinkSize,
        calcTextPaddingRight: this._calcTextPaddingRight,
        calcToggleIconPositionHover: this._calcToggleIconPositionHover,
        calcIconColor: this._calcIconColor,
        calcTextLinkColor: this._calcTextLinkColor,
        calcTextLinkBorder: this._calcTextLinkBorder
      }));
    }
  }]);

  return AccordionHeader;
}(React.Component);

_defineProperty(AccordionHeader, "componentType", "AccordionHeader");

AccordionHeader.propTypes = propTypes;
export default AccordionHeader;